export enum LoginState{
    Success,
    Fail,
    NeedsActivation
}